/*
 * @providesModule BalanceBarV1Style
 * 
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';

const {
  viewPrimaryColor,
  viewDividerPrimaryColor,
  fontSizeH2,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  balanceView: {
    ...viewPrimaryColor,
    flex: 1,
    flexDirection: 'row',
    ...Sizes.select({
      portraitTablet: {
        justifyContent: 'center',
      },
      other: {
        justifyContent: 'flex-end',
      },
    }),
  },

  balanceViewBorder: {
    borderColor: viewDividerPrimaryColor.backgroundColor,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },

  balanceContainer: {
    ...viewPrimaryColor,
    ...Sizes.select({
      portraitTablet: {
      },
      other: {
        flex: 1,
      },
    }),
  },

  balanceBorder_none: {},

  balanceBorder_divider: {
    borderColor: viewDividerPrimaryColor.backgroundColor,
    borderRightWidth: 0.5,
  },

  balanceBorder_surround: {
    borderColor: viewDividerPrimaryColor.backgroundColor,
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
  },

  balanceBorderPortraitTabletCenter: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },

  balanceBorderPortraitTabletNone: {
    borderLeftWidth: 0,
    borderRightWidth: 0,
  },

  counterView: {
    ...viewPrimaryColor,
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    flex: 1,
  },

  countingLabel: {
    textAlign: 'center',
    justifyContent: 'center',
    ...fontSizeH2,
  },

  countingLabelContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    flex: 1,
    ...Sizes.select({
      portraitTablet: {
        marginHorizontal: 31,
      },
      other: {
        marginHorizontal: 10,
      },
    }),
  },
  
  ticketzZBalanceContainer: {
    ...viewPrimaryColor,
    alignItems: 'center',
  },

  cashContainer: {
    flexDirection: 'column',
  },

});
